<template>
  <div class="floating-textarea">
    <textarea
      :id="id"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      @focus="focused = true"
      @blur="focused = false"
      rows="4"
    ></textarea>
    <label :class="{ active: focused || modelValue }">{{ placeholder }}</label>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: 'Введите текст' },
  id: { type: String, default: 'textarea-' + Math.random().toString(36).substr(2, 9) }
});

const focused = ref(false);
</script>

<style scoped>
.floating-textarea {
  position: relative;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  height: fit-content;
}

.floating-textarea textarea {
  background-color: var(--color-0);
  border: 0.1rem solid var(--grey-0);
  color: black;
  padding: 0.5rem 1rem;
  width: 100%;
  box-sizing: border-box;
  border-radius: 0.5rem;
  font-size: 1rem;
  outline: none;
  resize: vertical;
}

.floating-textarea textarea:focus {
  border: 0.1rem solid var(--grey-0);
}

.floating-textarea label {
  position: absolute;
  left: 1rem;
  top: 0.5rem;
  color: #9a9a9a;
  font-size: 1rem;
  pointer-events: none;
  transition: 0.3s ease all;
  background: transparent;
  line-height: 1.2;
}

.floating-textarea label.active {
  top: -1.15rem;
  left: 0.5rem;
  font-size: 0.8rem;
  color: var(--blue-0);
  line-height: 0.8;
}
</style>
